import { render, staticRenderFns } from "./ShipmentTypeSelectionStep.vue?vue&type=template&id=9179a09c&scoped=true&"
import script from "./ShipmentTypeSelectionStep.vue?vue&type=script&lang=js&"
export * from "./ShipmentTypeSelectionStep.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentTypeSelectionStep.vue?vue&type=style&index=0&id=9179a09c&prod&lang=scss&"
import style1 from "./ShipmentTypeSelectionStep.vue?vue&type=style&index=1&id=9179a09c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9179a09c",
  null
  
)

export default component.exports